import { PageTypeAdmin, PageTypePortal } from "@/lib/types";

export type MakeupNavBadge = {
  count: number;
  tooltipSuffix: string;
};

export function isMakeupRequestsNavHref(href: string): boolean {
  return href === PageTypeAdmin.MakeupRequests || href === PageTypePortal.Makeups;
}

export function groupContainsMakeupRequestsNav(
  items: ReadonlyArray<{ href: string }>,
): boolean {
  return items.some((item) => isMakeupRequestsNavHref(item.href));
}

export function buildMakeupNavBadgeLabel(
  itemLabel: string,
  badge: MakeupNavBadge,
): string {
  const countLabel = badge.count > 9 ? "9+" : String(badge.count);
  return `${itemLabel} (${countLabel} ${badge.tooltipSuffix})`;
}
